// src/pages/supervisors/AssignDelegatesToSupervisorPage/index.js (VERSION CORRIGÉE)

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Checkbox, Button, Typography, Spin, Row, Col, Divider, Alert, Empty } from 'antd'; // Empty ajouté
import { SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { fetchSupervisors, assignDelegatesToSupervisor } from '../../../redux/slices/supervisors/supervisorsThunk';
import { getDelegatesList } from '../../../redux/slices/delegates/delegatesThunk';

const { Title, Text } = Typography;
const CheckboxGroup = Checkbox.Group;

const AssignDelegatesToSupervisorPage = () => {
  const { id: supervisorId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const [selectedDelegateIds, setSelectedDelegateIds] = useState([]);
  
  // Sélecteurs pour récupérer les données de Redux
  const { data: supervisors, loading: loadingSupervisors } = useSelector(state => state.supervisors.supervisorsList);
  
  // ====================== DÉBUT DE LA CORRECTION ======================
  // On va chercher plus profondément dans la structure de l'état
  const delegatesListState = useSelector(state => state.delegates.delegatesList);
  const loadingDelegates = delegatesListState.loading;
  // La liste des délégués se trouve dans `delegatesListState.data.data`
  const allDelegates = delegatesListState.data?.data || [];
  // ======================= FIN DE LA CORRECTION =======================

  const supervisor = supervisors.find(s => String(s.id) === supervisorId);

  useEffect(() => {
    if (supervisors.length === 0) {
      dispatch(fetchSupervisors());
    }
    // On charge TOUS les délégués pour la liste d'assignation
    dispatch(getDelegatesList({ page: 1, itemsPerPage: 1000, filter: {} }));
  }, [dispatch, supervisors.length]);

  useEffect(() => {
    if (supervisor) {
      const currentlyAssignedIds = supervisor.delegates.map(d => d.id);
      setSelectedDelegateIds(currentlyAssignedIds);
    }
  }, [supervisor]);

  const handleSave = () => {
    dispatch(assignDelegatesToSupervisor({ supervisorId: parseInt(supervisorId), delegateIds: selectedDelegateIds }))
      .unwrap()
      .then(() => {
        // On met à jour la liste des superviseurs après l'assignation pour voir les changements
        dispatch(fetchSupervisors()); 
        history.push('/superviseurs');
      });
  };

  const isLoading = loadingSupervisors || loadingDelegates;

  if (isLoading && !supervisor) {
    return <Spin tip="Chargement des données..." style={{ display: 'block', marginTop: '50px' }} />;
  }

  if (!supervisor) {
    // Si le chargement est terminé mais que le superviseur n'est toujours pas trouvé
    return <Alert message="Erreur" description={`Superviseur avec l'ID ${supervisorId} non trouvé. Il est possible que la liste se charge encore.`} type="error" />;
  }

  const delegateOptions = allDelegates.map(delegate => ({
    label: `${delegate.firstname} ${delegate.lastname}`,
    value: delegate.id,
  }));

  return (
    <>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => history.push('/superviseurs')}
        style={{ marginBottom: '16px' }}
      >
        Retour à la liste des superviseurs
      </Button>
      <Card>
        <Title level={4}>Assigner des Délégués à <Text type="success">{supervisor.user?.firstName} {supervisor.user?.lastName}</Text></Title>
        <Divider />
        <Title level={5}>Sélectionnez les délégués à superviser :</Title>
        
        {isLoading ? (
            <Spin tip="Chargement de la liste des délégués..." />
        ) : delegateOptions.length > 0 ? (
            <CheckboxGroup
              style={{ width: '100%' }}
              value={selectedDelegateIds}
              onChange={(checkedValues) => setSelectedDelegateIds(checkedValues)}
            >
              <Row gutter={[16, 16]}>
                {delegateOptions.map(option => (
                  <Col xs={24} sm={12} md={8} lg={6} key={option.value}>
                    <Checkbox value={option.value}>{option.label}</Checkbox>
                  </Col>
                ))}
              </Row>
            </CheckboxGroup>
        ) : (
            <Empty description="Aucun délégué à assigner n'a été trouvé." />
        )}

        <Divider />
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSave}
          loading={loadingSupervisors}
          disabled={isLoading}
        >
          Enregistrer les modifications
        </Button>
      </Card>
    </>
  );
};

export default AssignDelegatesToSupervisorPage;